import React, { useState, useEffect } from "react";
import {
  EventApplicationRetailService,
  EventApplicationService,
  EventService,
} from "../../../services";
import { AuthService } from "../../../services";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";

import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { injectModels } from "../../../redux/injectModels";
import { ApplicationStatus } from "../../../constants/Enum";
import {
  addDefaultImg,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { TraderUnitService } from "../../../services";
import Swal from "sweetalert2";
import { globalConstant } from "../../../constants/globalConstant";
import { toast } from "react-toastify";
//import _ from "lodash";

const ApplicationList = (props) => {
  const loginUser = AuthService.getLoginUser();
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getApplicationData();
  }, []);

  const getApplicationData = async () => {
    try {
      if (loginUser) {
        props.application.setLoading(true);
        TraderUnitService.removeSelectedTraderUnit();
        const res = await EventApplicationRetailService.getMyApplicationsForTraderRetailers(
          loginUser?.id
        );
        if (res?.isSuccess && res?.data?.length > 0) {
          setFilteredData(res?.data);
        }
        props.application.setLoading(false);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleView = async (id, eventId, type) => {
    try {
      if (type === "R") {
        navigate(
          routes.SUBMISSION_RETAILER_DETAILS_TRADER.replace(
            ":eventId",
            eventId
          ).replace(":appId", id)
        );
      } else {
        navigate(
          routes.SUBMISSION_CATERER_DETAILS_TRADER.replace(
            ":eventId",
            eventId
          ).replace(":appId", id)
        );
      }
    } catch (error) {}
  };

  const handleMessageClick = async (e, id) => {
    try {
      e.preventDefault();
      props.application.setLoading(true);
      const res = await EventService.getEventOrganiserBussnessProfileByEventId(
        id
      );
      if (res?.isSuccess && res?.data) {
        props.application.setLoading(false);
        navigate(routes.MESSAGE_INBOX, {
          state: {
            toUser: res?.data,
            isRedirect: true,
          },
        });
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (item) => {
    navigateApplication(item);
  };

  const handleRebid = async (item) => {
    let message =
      "<b>Are you sure you want to rebid this application?</b><br/> This action will discard your current bid and allow you to submit a new one";
    const pinkColor = globalConstant.COLOR_PINK;
    Swal.fire({
      title: "Confirm Rebid",
      html: `${message}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: pinkColor,
      cancelButtonColor: "#373737",
      confirmButtonText: `Yes, Rebid`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        cancelExistingBid(item);
        navigateApplication(item);
      }
    });
  };
  const cancelExistingBid = async (item) => {
    if (item.applicationFor === "R") {
      await EventApplicationRetailService.rebidRetailApplication({
        id: item?.id,
        status: ApplicationStatus.InComplete,
      });
    } else {
      await EventApplicationService.rebidCatersApplication({
        id: item?.id,
        status: ApplicationStatus.InComplete,
      });
    }
  };
  const navigateApplication = (item) => {
    try {
      TraderUnitService.setSelectedTraderUnit({
        id: item?.traderPitchId,
        name: item?.traderPitchName,
      });
      navigate(
        item.applicationFor === "R"
          ? routes.RETAIL_APPLICATION_FORM.replace(
              ":eventId",
              item?.eventId
            ).replace(":pitchId", item.pitchId)
          : routes.CATER_APPLICATION_FORM.replace(
              ":eventId",
              item?.eventId
            ).replace(":unitId", item?.pitchId),
        { state: { isEdit: true, applicationId: item?.applicationId } }
      );
    } catch (error) {
      // props.application.setLoading(false);
      // toast.error("Something went wrong");
    }
  };
  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };
  const addDays = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
  };
  const IsAuctionRunning = (item) => {
    const bidDate = new Date(item?.auctionStartDate);
    const bidEndDate = addDays(bidDate, item?.auctionsDays);
    const today = new Date();
    if (item.isRebid && (today < bidDate || today > bidEndDate)) {
      return false;
    } else {
      return true;
    }
  };
  const IsClosed = (item) => {
    const deadlineDate = new Date(item?.deadLine);

    // Normalize both dates to compare only the date (ignore time)
    const deadlineDateOnly = new Date(
      deadlineDate.getFullYear(),
      deadlineDate.getMonth(),
      deadlineDate.getDate()
    );
    const todayDateOnly = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
    return deadlineDateOnly >= todayDateOnly ? false : true;
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container mt-3">
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Application</th>
                  <th>Trader Unit</th>
                  <th>Deadline</th>
                  <th>Event date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr style={{ verticalAlign: "middle" }} key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img
                                style={{
                                  width: 70,
                                  height: 50,
                                  objectFit: "none",
                                  overflow: "hidden",
                                  marginRight: 10,
                                }}
                                alt=""
                                src={item?.coverPicSquare}
                                onError={addDefaultImg}
                              ></img>
                              <div>
                                <span>{item?.pitchTitle}</span>
                                <br />
                                {/* <h4>{item.applicationTitile}</h4> */}
                                <h5>{item?.eventName}</h5>
                              </div>
                            </div>
                          </td>
                          <td>{item?.traderPitchName}</td>
                          <td>{formatDateENGB(item?.deadLine)}</td>
                          <td>{formatDateENGB(item?.startDate)}</td>
                          <td>{item?.statusName}</td>

                          <td>
                            <div className="delete-create">
                              {!IsClosed(item) &&
                                (item.status === ApplicationStatus.InComplete ||
                                  item.status == null) && (
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();
                                      // handleEdit(
                                      //   item.applicationId,
                                      //   item.eventId,
                                      //   item.applicationFor
                                      // );
                                      handleEdit(item);
                                    }}
                                    style={{ marginRight: "10px" }}
                                    title="Edit"
                                  >
                                    <i className="ri-pencil-line"></i>
                                  </Link>
                                )}
                              {(item?.status !== ApplicationStatus.InComplete ||
                                item?.status === null ||
                                IsClosed(item?.deadLine)) && (
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleView(
                                      item?.id,
                                      item?.eventId,
                                      item?.applicationFor
                                    );
                                  }}
                                  style={{ marginRight: "10px" }}
                                  title="View"
                                >
                                  <i className="fa-solid fa-eye"></i>
                                </Link>
                              )}
                              {item.isRebid &&
                                IsAuctionRunning(item) &&
                                !IsClosed(item) &&
                                item.status === ApplicationStatus.Awaiting && (
                                  <Link
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleRebid(item);
                                    }}
                                    style={{ marginRight: "10px" }}
                                    title="Rebid"
                                  >
                                    <i className="fa-solid fa-arrow-up-right-dots"></i>
                                  </Link>
                                )}

                              {(item?.status === ApplicationStatus.Approved ||
                                item?.status ===
                                  ApplicationStatus.Completed) && (
                                <Link
                                  title="Send A Message To The Event Organiser"
                                  onClick={async (e) => {
                                    handleMessageClick(e, item?.eventId);
                                  }}
                                >
                                  <i className="fa-solid fa-comment-dots"></i>
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(ApplicationList);
